import { useCallback, useMemo } from "react"
import { useAppDispatch, useAppSelector } from "@/app/store/store"
import { pin as pin_func, unpin as unpin_func } from "./slice"

export function useStoreHeaderPin() {
  const dispatch = useAppDispatch()
  const pin = useAppSelector(state => state.header_pin_slice.value)

  const topin = useCallback(() => {
    dispatch(pin_func())
  }, [dispatch])

  const unpin = useCallback(() => {
    dispatch(unpin_func())
  }, [dispatch])

  return useMemo(() => ({
    pin,
    topin,
    unpin
  }), [pin, topin, unpin])
}